import React, { useEffect, useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { useSelector } from "react-redux";
import ItemService from "../../../../services/inventory_appCommonService";
const StockDetails = () => {
  localStorage.setItem("menu", "stock");
  localStorage.setItem("submenu", "stcok-list");

  const stockData = useSelector((state) => state?.inventory?.stock?.stockNr)

  const [isCardVisible, setCardVisible] = useState(true);
  const [formInputs, setFormInputs] = useState({
    slNo: "",
    stockCode: "",
    stockLongText: "",
    stockGroup: "",
    uOM: "",
    plant: "",
  });

  const [validation, setValidation] = useState({
    slNo: "",
    stockCode: "",
    stockLongText: "",
    stockGroup: "",
    uOM: "",
    plant: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const loadFirstLevelData = async (page) => {
    if (stockData) {
      let obj = {
        documentNumber: stockData,
      };
      await ItemService.getStockDatails(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    }
  };

  useEffect(() => {
    loadFirstLevelData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Stock Details<span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
              {stockData}
            </span></h2>
            <p className="subText">Stock Details</p>
            <hr />
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SD</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Stock Details</span>
                      <span className="subHeaderTitle">Stock Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sl No."
                          name="slNo"
                          id="slNo"
                          extraLabel=""
                          value={formInputs.slNo || ""}
                          onChange={onInputChange}
                          error={validation.slNo || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Stock Code"
                          name="stockCode"
                          id="stockCode"
                          value={formInputs.stockCode || ""}
                          onChange={onInputChange}
                          error={validation.stockCode || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product Name"
                          name="productName"
                          id="productName"
                          value={formInputs.productName || ""}
                          onChange={onInputChange}
                          error={validation.productName || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Material Name"
                          name="materialName"
                          id="materialName"
                          value={formInputs.materialName || ""}
                          onChange={onInputChange}
                          error={validation.materialName || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Quantity"
                          name="quantity"
                          id="quantity"
                          value={formInputs.quantity || ""}
                          onChange={onInputChange}
                          error={validation.quantity || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="UOM"
                          name="uOM"
                          id="uOM"
                          extraLabel=""
                          value={formInputs.uOM || ""}
                          onChange={onInputChange}
                          error={validation.uOM || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Batch Number"
                          name="batchNumber"
                          id="batchNumber"
                          value={formInputs.batchNumber || ""}
                          onChange={onInputChange}
                          error={validation.batchNumber || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Supplier Namer"
                          name="supplierName"
                          id="supplierName"
                          value={formInputs.supplierName || ""}
                          onChange={onInputChange}
                          error={validation.supplierName || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Storage Location"
                          name="storageLocation"
                          id="storageLocation"
                          value={formInputs.storageLocation || ""}
                          onChange={onInputChange}
                          error={validation.storageLocation || ""}
                          // required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Stock Group"
                          name="stockGroup"
                          id="stockGroup"
                          extraLabel=""
                          value={formInputs.stockGroup || ""}
                          onChange={onInputChange}
                          error={validation.stockGroup || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Stock Description"
                          type="text"
                          name="stockDesc"
                          id="stockDesc"
                          value={formInputs.stockDesc || ""}
                          onChange={onInputChange}
                          error={validation.stockDesc || ""}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default StockDetails;
